(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('gg-contact-form')) return;

    class GGContactForm extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        if (!form || this.ready) return;
        this.ready = true;
        this.form = form;
        this.pills = Array.from(this.querySelectorAll('[data-gg-interest]'));
        this.hiddenInterest = this.querySelector('[data-gg-interest-value]');
        this.group = this.querySelector('.gg-field--pills');
        form.noValidate = true;

        this.pills.forEach((pill) => pill.addEventListener('change', () => this.syncInterest(true)));
        this.syncInterest(false);

        form.querySelectorAll('.gg-input').forEach((input) => {
          input.addEventListener('input', () => {
            if (input.closest('.gg-field').classList.contains('is-invalid')) this.check(input);
          });
          input.addEventListener('blur', () => { if (input.value) this.check(input); });
        });

        form.addEventListener('submit', (event) => this.onSubmit(event));

        const done = this.querySelector('.gg-form__done');
        if (done && !(window.Shopify && window.Shopify.designMode)) done.focus({ preventScroll: true });
      }

      syncInterest(validate) {
        const picked = this.pills.filter((pill) => pill.checked).map((pill) => pill.value);
        if (this.hiddenInterest) this.hiddenInterest.value = picked.join(', ');
        if (validate && picked.length && this.group) this.clear(this.group);
        return picked.length;
      }

      check(input) {
        const field = input.closest('.gg-field');
        const value = input.value.trim();
        let message = '';
        if (input.required && !value) message = field.dataset.msgRequired;
        else if (input.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) message = field.dataset.msgEmail;
        if (message) this.fail(field, message, input); else this.clear(field, input);
        return !message;
      }

      fail(field, message, input) {
        field.classList.add('is-invalid');
        const error = field.querySelector('.gg-field__err');
        if (error) { error.textContent = message || ''; error.hidden = false; }
        if (input) input.setAttribute('aria-invalid', 'true');
      }

      clear(field, input) {
        field.classList.remove('is-invalid');
        const error = field.querySelector('.gg-field__err');
        if (error) { error.hidden = true; error.textContent = ''; }
        if (input) input.removeAttribute('aria-invalid');
      }

      onSubmit(event) {
        let first = null;
        this.form.querySelectorAll('.gg-input[required]').forEach((input) => {
          if (!this.check(input) && !first) first = input;
        });
        const chosen = this.syncInterest(false);
        if (this.group && this.group.hasAttribute('data-required') && !chosen) {
          this.fail(this.group, this.group.dataset.msgInterest);
          if (!first) first = this.pills[0];
        }
        if (first) {
          event.preventDefault();
          first.focus();
          return;
        }
        const button = this.form.querySelector('.gg-form__submit');
        if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
      }
    }

    customElements.define('gg-contact-form', GGContactForm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gg-review-belt')) {
    customElements.define('gg-review-belt', class extends HTMLElement {
      connectedCallback() {
        if (!(window.Shopify && window.Shopify.designMode)) return;
        this.onSelect = (event) => {
          const card = this.querySelector('[data-block-id="' + event.detail.blockId + '"]');
          const track = this.querySelector('.gg-rev__track');
          if (!card || !track) return;
          track.style.animation = 'none';
          const x = Math.max(0, card.offsetLeft - (this.clientWidth - card.offsetWidth) / 2);
          track.style.transform = 'translate3d(' + (-x) + 'px, 0, 0)';
        };
        this.onDeselect = (event) => {
          const track = this.querySelector('.gg-rev__track');
          if (!track || !this.querySelector('[data-block-id="' + event.detail.blockId + '"]')) return;
          track.style.animation = '';
          track.style.transform = '';
        };
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
      }
      disconnectedCallback() {
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-tap-tech"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tap-tech-carousel')) return;

    class TapTechCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.gg-tt__slide'));
        this.dots = Array.from(this.querySelectorAll('.gg-tt__dot'));
        this.pauseBtn = this.querySelector('.gg-tt__pause');
        this.count = this.slides.length;
        this.current = 0;
        this.flags = { hover: false, focus: false, offscreen: true, editor: false };
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.auto = this.dataset.autoplay === 'true';
        this.userPaused = this.reduce;
        this.timers = [];
        if (this.count < 2) return;

        this.style.setProperty('--gg-dur', (parseInt(this.dataset.interval, 10) || 4500) + 'ms');
        this.classList.toggle('is-auto', this.auto);

        this.onDot = (event) => {
          const index = this.dots.indexOf(event.currentTarget);
          if (index > -1) this.go(index);
        };
        this.onFillEnd = (event) => {
          if (event.target.parentElement === this.dots[this.current]) this.go(this.current + 1, 1);
        };
        this.dots.forEach((dot) => {
          dot.addEventListener('click', this.onDot);
          dot.addEventListener('animationend', this.onFillEnd);
        });
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', () => { this.userPaused = !this.userPaused; this.sync(); });
        }

        this.addEventListener('mouseenter', () => { this.flags.hover = true; this.sync(); });
        this.addEventListener('mouseleave', () => { this.flags.hover = false; this.sync(); });
        this.addEventListener('focusin', () => { this.flags.focus = true; this.sync(); });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) { this.flags.focus = false; this.sync(); }
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') { this.go(this.current + 1, 1); event.preventDefault(); }
          if (event.key === 'ArrowLeft') { this.go(this.current - 1, -1); event.preventDefault(); }
        });

        let startX = null;
        let startY = 0;
        this.addEventListener('pointerdown', (event) => { startX = event.clientX; startY = event.clientY; });
        this.addEventListener('pointerup', (event) => {
          if (startX === null) return;
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          startX = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(this.current + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        });

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.flags.offscreen = !entry.isIntersecting;
            if (entry.isIntersecting) this.loadAll();
            this.sync();
          });
        }, { threshold: 0.25, rootMargin: '200px 0px' });
        this.observer.observe(this);

        this.mark(0);
        this.sync();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.timers.forEach(clearTimeout);
      }

      /* Hidden slides load as soon as the carousel is near the screen, so nothing pops in half way */
      loadAll() {
        this.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      }

      sync() {
        const f = this.flags;
        const paused = !this.auto || this.userPaused || f.hover || f.focus || f.offscreen || f.editor;
        this.classList.toggle('is-paused', paused);
        this.classList.toggle('is-user-paused', this.userPaused);
        if (this.pauseBtn) {
          this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
          this.pauseBtn.setAttribute('aria-pressed', String(this.userPaused));
        }
      }

      mark(index) {
        this.dots.forEach((dot, i) => {
          dot.classList.remove('is-active');
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        const dot = this.dots[index];
        if (dot) { void dot.offsetWidth; dot.classList.add('is-active'); }
      }

      go(target, direction) {
        const next = (target + this.count) % this.count;
        if (next === this.current) return;
        const dir = direction || (next > this.current ? 1 : -1);
        const incoming = this.slides[next];
        const outgoing = this.slides[this.current];

        incoming.classList.add('is-instant');
        incoming.dataset.state = dir > 0 ? 'from-next' : 'from-prev';
        void incoming.offsetWidth;
        incoming.classList.remove('is-instant');
        incoming.dataset.state = 'active';
        incoming.removeAttribute('aria-hidden');

        outgoing.dataset.state = dir > 0 ? 'to-prev' : 'to-next';
        outgoing.setAttribute('aria-hidden', 'true');
        this.timers.push(setTimeout(() => {
          if (outgoing.dataset.state.indexOf('to-') === 0) {
            outgoing.classList.add('is-instant');
            outgoing.dataset.state = 'idle';
            void outgoing.offsetWidth;
            outgoing.classList.remove('is-instant');
          }
        }, 950));

        this.current = next;
        this.mark(next);
      }

      /* Theme editor: selecting a slide block shows it and holds it until deselected */
      select(slide) {
        const index = this.slides.indexOf(slide);
        if (index < 0) return;
        this.flags.editor = true;
        this.go(index);
        this.sync();
      }

      release() {
        this.flags.editor = false;
        this.sync();
      }
    }

    customElements.define('tap-tech-carousel', TapTechCarousel);

    document.addEventListener('shopify:block:select', (event) => {
      const carousel = event.target.closest && event.target.closest('tap-tech-carousel');
      if (carousel && carousel.select) carousel.select(event.target);
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const carousel = event.target.closest && event.target.closest('tap-tech-carousel');
      if (carousel && carousel.release) carousel.release();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
